export const realEstateData = [
  { x: Date.UTC(2004, 0, 1), y: 1000, marker: { enabled: true } },
  { x: Date.UTC(2005, 0, 1), y: 1055.78992992 },
  { x: Date.UTC(2006, 0, 1), y: 1136.10873346 },
  { x: Date.UTC(2007, 0, 1), y: 1250.61418597 },
  { x: Date.UTC(2008, 0, 1), y: 1393.20894695 },
  { x: Date.UTC(2009, 0, 1), y: 1460.52249116 },
  { x: Date.UTC(2010, 0, 1), y: 1524.89880867 },
  { x: Date.UTC(2011, 0, 1), y: 1630.98657784 },
  { x: Date.UTC(2012, 0, 1), y: 1728.81613612 },
  { x: Date.UTC(2013, 0, 1), y: 1806.5368101 },
  { x: Date.UTC(2014, 0, 1), y: 1891.99996043 },
  { x: Date.UTC(2015, 0, 1), y: 2002.19873316 },
  { x: Date.UTC(2016, 0, 1), y: 2125.64618912 },
  { x: Date.UTC(2017, 0, 1), y: 2267.52427522 },
  { x: Date.UTC(2018, 0, 1), y: 2395.42477909 },
  { x: Date.UTC(2019, 0, 1), y: 2589.02177534 },
  { x: Date.UTC(2020, 0, 1), y: 2673.04854854 },
  { x: Date.UTC(2021, 0, 1), y: 2676.63963233 },
  { x: Date.UTC(2022, 0, 1), y: 2634.82840108 },
  { x: Date.UTC(2023, 0, 1), y: 2565.10628071 },
  { x: Date.UTC(2024, 0, 1), y: 2492.57590762, marker: { enabled: true } },
];

export const forestData = [
  { x: Date.UTC(2004, 0, 1), y: 1000, marker: { enabled: true } },
  { x: Date.UTC(2005, 0, 1), y: 1013.1 },
  { x: Date.UTC(2006, 0, 1), y: 1020.29 },
  { x: Date.UTC(2007, 0, 1), y: 1057.26 },
  { x: Date.UTC(2008, 0, 1), y: 1159.14 },
  { x: Date.UTC(2009, 0, 1), y: 1460.69 },
  { x: Date.UTC(2010, 0, 1), y: 1344.27 },
  { x: Date.UTC(2011, 0, 1), y: 1103.03 },
  { x: Date.UTC(2012, 0, 1), y: 1286.39 },
  { x: Date.UTC(2013, 0, 1), y: 1328.71 },
  { x: Date.UTC(2014, 0, 1), y: 1304.26 },
  { x: Date.UTC(2015, 0, 1), y: 1366.78 },
  { x: Date.UTC(2016, 0, 1), y: 1402.43 },
  { x: Date.UTC(2017, 0, 1), y: 1442.36 },
  { x: Date.UTC(2018, 0, 1), y: 1512.52 },
  { x: Date.UTC(2019, 0, 1), y: 1615.94 },
  { x: Date.UTC(2020, 0, 1), y: 1833.05 },
  { x: Date.UTC(2021, 0, 1), y: 1824.42 },
  { x: Date.UTC(2022, 0, 1), y: 1865.62 },
  { x: Date.UTC(2023, 0, 1), y: 2064.08 },
  { x: Date.UTC(2024, 0, 1), y: 2173.48, marker: { enabled: true } },
];

export const stockData = [
  { x: Date.UTC(2004, 0, 1), y: 1000, marker: { enabled: true } },
  { x: Date.UTC(2004, 1, 2), y: 1018.64289 },
  { x: Date.UTC(2004, 2, 1), y: 1043.191292 },
  { x: Date.UTC(2004, 3, 1), y: 1031.013587 },
  { x: Date.UTC(2004, 4, 3), y: 1005.191447 },
  { x: Date.UTC(2004, 5, 1), y: 1005.1239 },
  { x: Date.UTC(2004, 6, 1), y: 1019.424502 },
  { x: Date.UTC(2004, 7, 2), y: 993.476918 },
  { x: Date.UTC(2004, 8, 1), y: 998.099043 },
  { x: Date.UTC(2004, 9, 1), y: 1025.600201 },
  { x: Date.UTC(2004, 10, 1), y: 1037.922649 },
  { x: Date.UTC(2004, 11, 1), y: 1099.534893 },
  { x: Date.UTC(2005, 0, 3), y: 1120.831403 },
  { x: Date.UTC(2005, 1, 1), y: 1107.736992 },
  { x: Date.UTC(2005, 2, 1), y: 1138.605836 },
  { x: Date.UTC(2005, 3, 1), y: 1107.920333 },
  { x: Date.UTC(2005, 4, 2), y: 1086.305388 },
  { x: Date.UTC(2005, 5, 1), y: 1108.557202 },
  { x: Date.UTC(2005, 6, 1), y: 1107.601899 },
  { x: Date.UTC(2005, 7, 1), y: 1150.272117 },
  { x: Date.UTC(2005, 8, 1), y: 1164.032345 },
  { x: Date.UTC(2005, 9, 3), y: 1177.985564 },
  { x: Date.UTC(2005, 10, 1), y: 1152.896789 },
  { x: Date.UTC(2005, 11, 1), y: 1200.845299 },
  { x: Date.UTC(2006, 0, 2), y: 1214.981859 },
  { x: Date.UTC(2006, 1, 1), y: 1268.507797 },
  { x: Date.UTC(2006, 2, 1), y: 1270.196464 },
  { x: Date.UTC(2006, 3, 3), y: 1296.259843 },
  { x: Date.UTC(2006, 4, 1), y: 1327.012892 },
  { x: Date.UTC(2006, 5, 1), y: 1285.336576 },
  { x: Date.UTC(2006, 6, 3), y: 1281.418867 },
  { x: Date.UTC(2006, 7, 1), y: 1272.444805 },
  { x: Date.UTC(2006, 8, 1), y: 1317.324765 },
  { x: Date.UTC(2006, 9, 2), y: 1327.360275 },
  { x: Date.UTC(2006, 10, 1), y: 1369.557666 },
  { x: Date.UTC(2006, 11, 1), y: 1402.066929 },
  { x: Date.UTC(2007, 0, 1), y: 1431.584839 },
  { x: Date.UTC(2007, 1, 1), y: 1461.025552 },
  { x: Date.UTC(2007, 2, 1), y: 1429.606685 },
  { x: Date.UTC(2007, 3, 2), y: 1464.96256 },
  { x: Date.UTC(2007, 4, 1), y: 1520.678941 },
  { x: Date.UTC(2007, 5, 1), y: 1568.260769 },
  { x: Date.UTC(2007, 6, 2), y: 1560.203412 },
  { x: Date.UTC(2007, 7, 1), y: 1501.785163 },
  { x: Date.UTC(2007, 8, 3), y: 1507.874016 },
  { x: Date.UTC(2007, 9, 1), y: 1591.303844 },
  { x: Date.UTC(2007, 10, 1), y: 1595.308399 },
  { x: Date.UTC(2007, 11, 3), y: 1547.842365 },
  { x: Date.UTC(2008, 0, 1), y: 1533.117184 },
  { x: Date.UTC(2008, 1, 1), y: 1435.425351 },
  { x: Date.UTC(2008, 2, 3), y: 1391.220858 },
  { x: Date.UTC(2008, 3, 1), y: 1416.319284 },
  { x: Date.UTC(2008, 4, 1), y: 1462.801065 },
  { x: Date.UTC(2008, 5, 2), y: 1462.858962 },
  { x: Date.UTC(2008, 6, 1), y: 1343.774124 },
  { x: Date.UTC(2008, 7, 1), y: 1304.529489 },
  { x: Date.UTC(2008, 8, 1), y: 1288.791107 },
  { x: Date.UTC(2008, 9, 1), y: 1142.784082 },
  { x: Date.UTC(2008, 10, 3), y: 927.792574 },
  { x: Date.UTC(2008, 11, 1), y: 801.22935 },
  { x: Date.UTC(2009, 0, 1), y: 887.978617 },
  { x: Date.UTC(2009, 1, 2), y: 799.839818 },
  { x: Date.UTC(2009, 2, 2), y: 688.831635 },
  { x: Date.UTC(2009, 3, 1), y: 788.906901 },
  { x: Date.UTC(2009, 4, 1), y: 864.810097 },
  { x: Date.UTC(2009, 5, 1), y: 959.645669 },
  { x: Date.UTC(2009, 6, 1), y: 938.754439 },
  { x: Date.UTC(2009, 7, 3), y: 1028.244172 },
  { x: Date.UTC(2009, 8, 1), y: 1029.247723 },
  { x: Date.UTC(2009, 9, 1), y: 1063.416705 },
  { x: Date.UTC(2009, 10, 2), y: 1070.364366 },
  { x: Date.UTC(2009, 11, 1), y: 1130.866914 },
  { x: Date.UTC(2010, 0, 1), y: 1127.518527 },
  { x: Date.UTC(2010, 1, 1), y: 1089.711672 },
  { x: Date.UTC(2010, 2, 1), y: 1100.60599 },
  { x: Date.UTC(2010, 3, 1), y: 1169.658021 },
  { x: Date.UTC(2010, 4, 3), y: 1160.182183 },
  { x: Date.UTC(2010, 5, 1), y: 1032.055736 },
  { x: Date.UTC(2010, 6, 1), y: 999.768411 },
  { x: Date.UTC(2010, 7, 2), y: 1111.789795 },
  { x: Date.UTC(2010, 8, 1), y: 1072.564459 },
  { x: Date.UTC(2010, 9, 1), y: 1142.687587 },
  { x: Date.UTC(2010, 10, 1), y: 1180.436545 },
  { x: Date.UTC(2010, 11, 1), y: 1174.038907 },
  { x: Date.UTC(2011, 0, 3), y: 1242.801451 },
  { x: Date.UTC(2011, 1, 1), y: 1283.647908 },
  { x: Date.UTC(2011, 2, 1), y: 1293.895708 },
  { x: Date.UTC(2011, 3, 1), y: 1294.436082 },
  { x: Date.UTC(2011, 4, 2), y: 1343.079358 },
  { x: Date.UTC(2011, 5, 1), y: 1288.781457 },
  { x: Date.UTC(2011, 6, 1), y: 1296.71337 },
  { x: Date.UTC(2011, 7, 1), y: 1251.765864 },
  { x: Date.UTC(2011, 8, 1), y: 1161.002393 },
  { x: Date.UTC(2011, 9, 3), y: 1037.141038 },
  { x: Date.UTC(2011, 10, 1), y: 1133.59773 },
  { x: Date.UTC(2011, 11, 1), y: 1142.948124 },
  { x: Date.UTC(2012, 0, 2), y: 1144.501698 },
  { x: Date.UTC(2012, 1, 1), y: 1213.505481 },
  { x: Date.UTC(2012, 2, 1), y: 1258.761772 },
  { x: Date.UTC(2012, 3, 2), y: 1277.848541 },
  { x: Date.UTC(2012, 4, 1), y: 1251.524626 },
  { x: Date.UTC(2012, 5, 1), y: 1112.561757 },
  { x: Date.UTC(2012, 6, 2), y: 1197.024085 },
  { x: Date.UTC(2012, 7, 1), y: 1204.357727 },
  { x: Date.UTC(2012, 8, 3), y: 1235.873089 },
  { x: Date.UTC(2012, 9, 1), y: 1272.589548 },
  { x: Date.UTC(2012, 10, 1), y: 1267.166512 },
  { x: Date.UTC(2012, 11, 3), y: 1268.23761 },
  { x: Date.UTC(2013, 0, 1), y: 1291.637718 },
  { x: Date.UTC(2013, 1, 1), y: 1367.135634 },
  { x: Date.UTC(2013, 2, 1), y: 1352.622742 },
  { x: Date.UTC(2013, 3, 1), y: 1377.991354 },
  { x: Date.UTC(2013, 4, 1), y: 1415.132392 },
  { x: Date.UTC(2013, 5, 3), y: 1421.124749 },
  { x: Date.UTC(2013, 6, 1), y: 1393.710437 },
  { x: Date.UTC(2013, 7, 1), y: 1471.466342 },
  { x: Date.UTC(2013, 8, 2), y: 1429.268952 },
  { x: Date.UTC(2013, 9, 1), y: 1499.063996 },
  { x: Date.UTC(2013, 10, 1), y: 1541.859657 },
  { x: Date.UTC(2013, 11, 2), y: 1564.516752 },
  { x: Date.UTC(2014, 0, 1), y: 1602.87363 },
  { x: Date.UTC(2014, 1, 3), y: 1516.828779 },
  { x: Date.UTC(2014, 2, 3), y: 1597.402347 },
  { x: Date.UTC(2014, 3, 1), y: 1624.691215 },
  { x: Date.UTC(2014, 4, 1), y: 1631.14675 },
  { x: Date.UTC(2014, 5, 2), y: 1657.084684 },
  { x: Date.UTC(2014, 6, 1), y: 1693.260769 },
  { x: Date.UTC(2014, 7, 1), y: 1645.978076 },
  { x: Date.UTC(2014, 8, 1), y: 1687.056122 },
  { x: Date.UTC(2014, 9, 1), y: 1620.329628 },
  { x: Date.UTC(2014, 10, 3), y: 1639.54184 },
  { x: Date.UTC(2014, 11, 1), y: 1669.26239 },
  { x: Date.UTC(2015, 0, 1), y: 1649.760692 },
  { x: Date.UTC(2015, 1, 2), y: 1634.967964 },
  { x: Date.UTC(2015, 2, 2), y: 1714.383588 },
  { x: Date.UTC(2015, 3, 1), y: 1677.232901 },
  { x: Date.UTC(2015, 4, 1), y: 1724.756832 },
  { x: Date.UTC(2015, 5, 1), y: 1715.956461 },
  { x: Date.UTC(2015, 6, 1), y: 1685.946426 },
  { x: Date.UTC(2015, 7, 3), y: 1699.455767 },
  { x: Date.UTC(2015, 8, 1), y: 1544.609773 },
  { x: Date.UTC(2015, 9, 1), y: 1532.325922 },
  { x: Date.UTC(2015, 10, 2), y: 1655.067933 },
  { x: Date.UTC(2015, 11, 1), y: 1650.185271 },
  { x: Date.UTC(2016, 0, 1), y: 1604.51405 },
  { x: Date.UTC(2016, 1, 1), y: 1511.656631 },
  { x: Date.UTC(2016, 2, 1), y: 1520.099969 },
  { x: Date.UTC(2016, 3, 1), y: 1582.657866 },
  { x: Date.UTC(2016, 4, 2), y: 1616.913695 },
  { x: Date.UTC(2016, 5, 1), y: 1614.231126 },
  { x: Date.UTC(2016, 6, 1), y: 1602.072719 },
  { x: Date.UTC(2016, 7, 1), y: 1657.470665 },
  { x: Date.UTC(2016, 8, 1), y: 1663.144589 },
  { x: Date.UTC(2016, 9, 3), y: 1662.440173 },
  { x: Date.UTC(2016, 10, 1), y: 1624.942103 },
  { x: Date.UTC(2016, 11, 1), y: 1648.757141 },
  { x: Date.UTC(2017, 0, 2), y: 1691.649298 },
  { x: Date.UTC(2017, 1, 1), y: 1730.5369 },
  { x: Date.UTC(2017, 2, 1), y: 1791.280686 },
  { x: Date.UTC(2017, 3, 3), y: 1784.168983 },
  { x: Date.UTC(2017, 4, 1), y: 1816.514204 },
  { x: Date.UTC(2017, 5, 1), y: 1855.700942 },
  { x: Date.UTC(2017, 6, 3), y: 1853.26926 },
  { x: Date.UTC(2017, 7, 1), y: 1901.333565 },
  { x: Date.UTC(2017, 8, 1), y: 1896.894782 },
  { x: Date.UTC(2017, 9, 2), y: 1934.4218 },
  { x: Date.UTC(2017, 10, 1), y: 1969.632932 },
  { x: Date.UTC(2017, 11, 1), y: 1996.844604 },
  { x: Date.UTC(2018, 0, 1), y: 2029.749498 },
  { x: Date.UTC(2018, 1, 1), y: 2134.987263 },
  { x: Date.UTC(2018, 2, 1), y: 2016.732283 },
  { x: Date.UTC(2018, 3, 2), y: 1967.095106 },
  { x: Date.UTC(2018, 4, 1), y: 2010.739926 },
  { x: Date.UTC(2018, 5, 1), y: 2035.269029 },
  { x: Date.UTC(2018, 6, 2), y: 2009.109155 },
  { x: Date.UTC(2018, 7, 1), y: 2074.031187 },
  { x: Date.UTC(2018, 8, 3), y: 2097.247954 },
  { x: Date.UTC(2018, 9, 1), y: 2111.500309 },
  { x: Date.UTC(2018, 10, 1), y: 1969.401343 },
  { x: Date.UTC(2018, 11, 3), y: 1994.190983 },
  { x: Date.UTC(2019, 0, 1), y: 1817.903736 },
  { x: Date.UTC(2019, 1, 1), y: 1958.420179 },
  { x: Date.UTC(2019, 2, 1), y: 2022.879034 },
  { x: Date.UTC(2019, 3, 1), y: 2057.076965 },
  { x: Date.UTC(2019, 4, 1), y: 2093.976764 },
  { x: Date.UTC(2019, 5, 3), y: 1973.386599 },
  { x: Date.UTC(2019, 6, 1), y: 2115.408368 },
  { x: Date.UTC(2019, 7, 1), y: 2097.016366 },
  { x: Date.UTC(2019, 8, 2), y: 2061.699089 },
  { x: Date.UTC(2019, 9, 1), y: 2082.821908 },
  { x: Date.UTC(2019, 10, 1), y: 2173.141501 },
  { x: Date.UTC(2019, 11, 2), y: 2196.618805 },
  { x: Date.UTC(2020, 0, 1), y: 2275.82214 },
  { x: Date.UTC(2020, 1, 3), y: 2269.038521 },
  { x: Date.UTC(2020, 2, 2), y: 2134.84252 },
  { x: Date.UTC(2020, 3, 1), y: 1718.841671 },
  { x: Date.UTC(2020, 4, 1), y: 1934.527945 },
  { x: Date.UTC(2020, 5, 1), y: 2088.090551 },
  { x: Date.UTC(2020, 6, 1), y: 2133.771422 },
  { x: Date.UTC(2020, 7, 3), y: 2242.62776 },
  { x: Date.UTC(2020, 8, 1), y: 2380.780068 },
  { x: Date.UTC(2020, 9, 1), y: 2296.607226 },
  { x: Date.UTC(2020, 10, 2), y: 2240.755751 },
  { x: Date.UTC(2020, 11, 1), y: 2517.571792 },
  { x: Date.UTC(2021, 0, 1), y: 2595.761927 },
  { x: Date.UTC(2021, 1, 1), y: 2603.327158 },
  { x: Date.UTC(2021, 2, 1), y: 2686.139416 },
  { x: Date.UTC(2021, 3, 1), y: 2740.649606 },
  { x: Date.UTC(2021, 4, 3), y: 2845.327698 },
  { x: Date.UTC(2021, 5, 1), y: 2877.508878 },
  { x: Date.UTC(2021, 6, 1), y: 2922.070403 },
  { x: Date.UTC(2021, 7, 2), y: 2969.26625 },
  { x: Date.UTC(2021, 8, 1), y: 3041.203489 },
  { x: Date.UTC(2021, 9, 1), y: 2916.888606 },
  { x: Date.UTC(2021, 10, 1), y: 3078.720858 },
  { x: Date.UTC(2021, 11, 1), y: 2979.755288 },
  { x: Date.UTC(2022, 0, 3), y: 3127.827312 },
  { x: Date.UTC(2022, 1, 1), y: 2978.442952 },
  { x: Date.UTC(2022, 2, 1), y: 2828.055041 },
  { x: Date.UTC(2022, 3, 1), y: 2949.928593 },
  { x: Date.UTC(2022, 4, 2), y: 2698.326772 },
  { x: Date.UTC(2022, 5, 1), y: 2673.334491 },
  { x: Date.UTC(2022, 6, 1), y: 2470.231203 },
  { x: Date.UTC(2022, 7, 1), y: 2652.906438 },
  { x: Date.UTC(2022, 8, 1), y: 2518.777984 },
  { x: Date.UTC(2022, 9, 3), y: 2344.748726 },
  { x: Date.UTC(2022, 10, 1), y: 2457.156091 },
  { x: Date.UTC(2022, 11, 1), y: 2645.013123 },
  { x: Date.UTC(2023, 0, 2), y: 2515.873475 },
  { x: Date.UTC(2023, 1, 1), y: 2711.459781 },
  { x: Date.UTC(2023, 2, 1), y: 2611.924888 },
  { x: Date.UTC(2023, 3, 3), y: 2705.370928 },
  { x: Date.UTC(2023, 4, 1), y: 2734.290567 },
  { x: Date.UTC(2023, 5, 1), y: 2732.418558 },
  { x: Date.UTC(2023, 6, 3), y: 2867.868998 },
  { x: Date.UTC(2023, 7, 1), y: 2941.755442 },
  { x: Date.UTC(2023, 8, 1), y: 2884.736375 },
  { x: Date.UTC(2023, 9, 2), y: 2739.289023 },
  { x: Date.UTC(2023, 10, 1), y: 2699.446117 },
  { x: Date.UTC(2023, 11, 1), y: 2934.132314 },
  { x: Date.UTC(2024, 0, 1), y: 3058.109464, marker: { enabled: true } },
];

export const interestData = [
  { x: Date.UTC(2004, 0, 2), y: 1000, marker: { enabled: true } },
  { x: Date.UTC(2004, 1, 2), y: 1007.258554 },
  { x: Date.UTC(2004, 2, 1), y: 1019.320068 },
  { x: Date.UTC(2004, 3, 1), y: 1027.360346 },
  { x: Date.UTC(2004, 4, 4), y: 1020.098136 },
  { x: Date.UTC(2004, 4, 5), y: 1020.132506 },
  { x: Date.UTC(2004, 5, 1), y: 1014.671405 },
  { x: Date.UTC(2004, 6, 1), y: 1019.662301 },
  { x: Date.UTC(2004, 7, 2), y: 1029.749395 },
  { x: Date.UTC(2004, 8, 1), y: 1041.664656 },
  { x: Date.UTC(2004, 9, 1), y: 1045.772912 },
  { x: Date.UTC(2004, 10, 1), y: 1057.695486 },
  { x: Date.UTC(2004, 11, 1), y: 1069.133961 },
  { x: Date.UTC(2005, 0, 4), y: 1077.898924 },
  { x: Date.UTC(2005, 1, 1), y: 1090.068666 },
  { x: Date.UTC(2005, 2, 1), y: 1081.725643 },
  { x: Date.UTC(2005, 3, 1), y: 1090.78677 },
  { x: Date.UTC(2005, 4, 3), y: 1107.493291 },
  { x: Date.UTC(2005, 5, 1), y: 1120.716788 },
  { x: Date.UTC(2005, 6, 1), y: 1129.022516 },
  { x: Date.UTC(2005, 7, 1), y: 1121.413685 },
  { x: Date.UTC(2005, 8, 1), y: 1139.93521 },
  { x: Date.UTC(2005, 9, 3), y: 1133.307739 },
  { x: Date.UTC(2005, 10, 1), y: 1121.059752 },
  { x: Date.UTC(2005, 11, 1), y: 1125.534373 },
  { x: Date.UTC(2006, 0, 3), y: 1132.324185 },
  { x: Date.UTC(2006, 1, 1), y: 1122.562505 },
  { x: Date.UTC(2006, 2, 1), y: 1125.551924 },
  { x: Date.UTC(2006, 3, 3), y: 1108.303534 },
  { x: Date.UTC(2006, 4, 2), y: 1101.711896 },
  { x: Date.UTC(2006, 5, 1), y: 1103.799662 },
  { x: Date.UTC(2006, 6, 3), y: 1101.86473 },
  { x: Date.UTC(2006, 7, 1), y: 1114.04471 },
  { x: Date.UTC(2006, 8, 1), y: 1129.366942 },
  { x: Date.UTC(2006, 9, 2), y: 1136.659866 },
  { x: Date.UTC(2006, 10, 1), y: 1140.971415 },
  { x: Date.UTC(2006, 11, 1), y: 1146.269443 },
  { x: Date.UTC(2007, 0, 2), y: 1131.976102 },
  { x: Date.UTC(2007, 1, 1), y: 1125.913169 },
  { x: Date.UTC(2007, 2, 1), y: 1138.118743 },
  { x: Date.UTC(2007, 3, 2), y: 1131.906632 },
  { x: Date.UTC(2007, 4, 1), y: 1131.421071 },
  { x: Date.UTC(2007, 5, 1), y: 1115.194992 },
  { x: Date.UTC(2007, 6, 2), y: 1115.596458 },
  { x: Date.UTC(2007, 7, 1), y: 1127.523419 },
  { x: Date.UTC(2007, 8, 3), y: 1136.462424 },
  { x: Date.UTC(2007, 9, 1), y: 1138.671581 },
  { x: Date.UTC(2007, 10, 1), y: 1148.88884 },
  { x: Date.UTC(2007, 11, 3), y: 1158.238086 },
  { x: Date.UTC(2008, 0, 2), y: 1157.745943 },
  { x: Date.UTC(2008, 1, 1), y: 1179.431659 },
  { x: Date.UTC(2008, 2, 3), y: 1184.923473 },
  { x: Date.UTC(2008, 3, 1), y: 1173.872569 },
  { x: Date.UTC(2008, 4, 1), y: 1170.105083 },
  { x: Date.UTC(2008, 5, 2), y: 1157.440274 },
  { x: Date.UTC(2008, 6, 1), y: 1141.713651 },
  { x: Date.UTC(2008, 7, 1), y: 1164.358057 },
  { x: Date.UTC(2008, 8, 1), y: 1182.271168 },
  { x: Date.UTC(2008, 9, 1), y: 1190.199563 },
  { x: Date.UTC(2008, 10, 3), y: 1201.960526 },
  { x: Date.UTC(2008, 11, 1), y: 1247.967444 },
  { x: Date.UTC(2009, 0, 2), y: 1259.858573 },
  { x: Date.UTC(2009, 1, 2), y: 1245.97328 },
  { x: Date.UTC(2009, 2, 2), y: 1258.439184 },
  { x: Date.UTC(2009, 3, 1), y: 1268.211833 },
  { x: Date.UTC(2009, 4, 1), y: 1275.711705 },
  { x: Date.UTC(2009, 5, 1), y: 1256.52034 },
  { x: Date.UTC(2009, 6, 1), y: 1275.015539 },
  { x: Date.UTC(2009, 7, 3), y: 1294.611295 },
  { x: Date.UTC(2009, 8, 1), y: 1302.93238 },
  { x: Date.UTC(2009, 9, 1), y: 1312.13391 },
  { x: Date.UTC(2009, 10, 2), y: 1313.555492 },
  { x: Date.UTC(2009, 11, 1), y: 1323.736188 },
  { x: Date.UTC(2010, 0, 4), y: 1313.521123 },
  { x: Date.UTC(2010, 1, 1), y: 1320.857191 },
  { x: Date.UTC(2010, 2, 1), y: 1334.273011 },
  { x: Date.UTC(2010, 3, 1), y: 1343.290993 },
  { x: Date.UTC(2010, 4, 4), y: 1332.729307 },
  { x: Date.UTC(2010, 5, 1), y: 1351.121398 },
  { x: Date.UTC(2010, 6, 1), y: 1344.398131 },
  { x: Date.UTC(2010, 7, 2), y: 1355.48121 },
  { x: Date.UTC(2010, 8, 1), y: 1385.760773 },
  { x: Date.UTC(2010, 9, 1), y: 1375.497444 },
  { x: Date.UTC(2010, 10, 1), y: 1369.105441 },
  { x: Date.UTC(2010, 11, 1), y: 1332.523821 },
  { x: Date.UTC(2011, 0, 3), y: 1330.453605 },
  { x: Date.UTC(2011, 1, 1), y: 1320.231227 },
  { x: Date.UTC(2011, 2, 1), y: 1319.263029 },
  { x: Date.UTC(2011, 3, 1), y: 1309.665153 },
  { x: Date.UTC(2011, 4, 2), y: 1318.300682 },
  { x: Date.UTC(2011, 5, 1), y: 1333.971729 },
  { x: Date.UTC(2011, 6, 1), y: 1328.356332 },
  { x: Date.UTC(2011, 7, 1), y: 1327.567295 },
  { x: Date.UTC(2011, 8, 1), y: 1368.669606 },
  { x: Date.UTC(2011, 9, 3), y: 1381.595478 },
  { x: Date.UTC(2011, 10, 1), y: 1357.810295 },
  { x: Date.UTC(2011, 11, 1), y: 1336.474124 },
  { x: Date.UTC(2012, 0, 3), y: 1365.90103 },
  { x: Date.UTC(2012, 1, 1), y: 1403.074977 },
  { x: Date.UTC(2012, 2, 1), y: 1427.566564 },
  { x: Date.UTC(2012, 3, 2), y: 1422.245867 },
  { x: Date.UTC(2012, 4, 1), y: 1418.892277 },
  { x: Date.UTC(2012, 5, 1), y: 1444.074911 },
  { x: Date.UTC(2012, 6, 2), y: 1430.517956 },
  { x: Date.UTC(2012, 7, 1), y: 1448.001082 },
  { x: Date.UTC(2012, 8, 3), y: 1457.465137 },
  { x: Date.UTC(2012, 9, 1), y: 1476.91537 },
  { x: Date.UTC(2012, 10, 1), y: 1489.629906 },
  { x: Date.UTC(2012, 11, 3), y: 1510.049068 },
  { x: Date.UTC(2013, 0, 2), y: 1520.565415 },
  { x: Date.UTC(2013, 1, 1), y: 1512.960972 },
  { x: Date.UTC(2013, 2, 1), y: 1518.906902 },
  { x: Date.UTC(2013, 3, 2), y: 1528.315381 },
  { x: Date.UTC(2013, 4, 1), y: 1565.322598 },
  { x: Date.UTC(2013, 5, 3), y: 1544.063942 },
  { x: Date.UTC(2013, 6, 1), y: 1525.645526 },
  { x: Date.UTC(2013, 7, 1), y: 1535.494227 },
  { x: Date.UTC(2013, 8, 2), y: 1525.056856 },
  { x: Date.UTC(2013, 9, 1), y: 1539.451842 },
  { x: Date.UTC(2013, 10, 1), y: 1559.460764 },
  { x: Date.UTC(2013, 11, 2), y: 1561.680159 },
  { x: Date.UTC(2014, 0, 2), y: 1558.67904 },
  { x: Date.UTC(2014, 1, 3), y: 1589.90925 },
  { x: Date.UTC(2014, 2, 3), y: 1603.706791 },
  { x: Date.UTC(2014, 3, 1), y: 1613.01143 },
  { x: Date.UTC(2014, 4, 1), y: 1629.799852 },
  { x: Date.UTC(2014, 5, 2), y: 1646.017887 },
  { x: Date.UTC(2014, 6, 1), y: 1664.137946 },
  { x: Date.UTC(2014, 7, 1), y: 1678.222144 },
  { x: Date.UTC(2014, 8, 1), y: 1709.333889 },
  { x: Date.UTC(2014, 9, 1), y: 1717.001952 },
  { x: Date.UTC(2014, 10, 3), y: 1713.711983 },
  { x: Date.UTC(2014, 11, 1), y: 1740.026618 },
  { x: Date.UTC(2015, 0, 2), y: 1767.019137 },
  { x: Date.UTC(2015, 1, 2), y: 1800.679347 },
  { x: Date.UTC(2015, 2, 2), y: 1809.858207 },
  { x: Date.UTC(2015, 3, 1), y: 1835.591485 },
  { x: Date.UTC(2015, 4, 1), y: 1808.947049 },
  { x: Date.UTC(2015, 5, 1), y: 1777.469671 },
  { x: Date.UTC(2015, 6, 1), y: 1733.364047 },
  { x: Date.UTC(2015, 7, 3), y: 1775.354847 },
  { x: Date.UTC(2015, 8, 1), y: 1753.427082 },
  { x: Date.UTC(2015, 9, 1), y: 1784.238276 },
  { x: Date.UTC(2015, 10, 2), y: 1791.260631 },
  { x: Date.UTC(2015, 11, 1), y: 1806.743011 },
  { x: Date.UTC(2016, 0, 4), y: 1793.313297 },
  { x: Date.UTC(2016, 1, 1), y: 1818.959554 },
  { x: Date.UTC(2016, 2, 1), y: 1836.610871 },
  { x: Date.UTC(2016, 3, 1), y: 1850.942237 },
  { x: Date.UTC(2016, 4, 3), y: 1837.584918 },
  { x: Date.UTC(2016, 5, 1), y: 1847.866529 },
  { x: Date.UTC(2016, 6, 1), y: 1894.022625 },
  { x: Date.UTC(2016, 7, 1), y: 1903.500574 },
  { x: Date.UTC(2016, 8, 1), y: 1895.009836 },
  { x: Date.UTC(2016, 9, 3), y: 1899.276777 },
  { x: Date.UTC(2016, 10, 1), y: 1857.414679 },
  { x: Date.UTC(2016, 11, 1), y: 1825.664539 },
  { x: Date.UTC(2017, 0, 3), y: 1835.614886 },
  { x: Date.UTC(2017, 1, 1), y: 1801.478621 },
  { x: Date.UTC(2017, 2, 1), y: 1821.819538 },
  { x: Date.UTC(2017, 3, 3), y: 1820.760664 },
  { x: Date.UTC(2017, 4, 1), y: 1827.684298 },
  { x: Date.UTC(2017, 5, 1), y: 1834.830236 },
  { x: Date.UTC(2017, 6, 3), y: 1827.299651 },
  { x: Date.UTC(2017, 7, 1), y: 1839.717292 },
  { x: Date.UTC(2017, 8, 1), y: 1844.157544 },
  { x: Date.UTC(2017, 9, 2), y: 1838.304485 },
  { x: Date.UTC(2017, 10, 1), y: 1859.174839 },
  { x: Date.UTC(2017, 11, 1), y: 1872.717168 },
  { x: Date.UTC(2018, 0, 2), y: 1843.019693 },
  { x: Date.UTC(2018, 1, 1), y: 1843.769973 },
  { x: Date.UTC(2018, 2, 1), y: 1848.62924 },
  { x: Date.UTC(2018, 3, 2), y: 1875.700005 },
  { x: Date.UTC(2018, 4, 1), y: 1868.518234 },
  { x: Date.UTC(2018, 5, 1), y: 1847.442394 },
  { x: Date.UTC(2018, 6, 2), y: 1862.721482 },
  { x: Date.UTC(2018, 7, 1), y: 1846.90272 },
  { x: Date.UTC(2018, 8, 3), y: 1843.304156 },
  { x: Date.UTC(2018, 9, 1), y: 1835.088374 },
  { x: Date.UTC(2018, 10, 1), y: 1838.648912 },
  { x: Date.UTC(2018, 11, 3), y: 1852.383564 },
  { x: Date.UTC(2019, 0, 2), y: 1873.014062 },
  { x: Date.UTC(2019, 1, 1), y: 1882.100052 },
  { x: Date.UTC(2019, 2, 1), y: 1878.834215 },
  { x: Date.UTC(2019, 3, 1), y: 1908.290371 },
  { x: Date.UTC(2019, 4, 1), y: 1913.789498 },
  { x: Date.UTC(2019, 5, 3), y: 1938.396624 },
  { x: Date.UTC(2019, 6, 1), y: 1988.184191 },
  { x: Date.UTC(2019, 7, 1), y: 2015.347096 },
  { x: Date.UTC(2019, 8, 2), y: 2060.486731 },
  { x: Date.UTC(2019, 9, 1), y: 2051.276426 },
  { x: Date.UTC(2019, 10, 1), y: 2024.710967 },
  { x: Date.UTC(2019, 11, 2), y: 1999.559046 },
  { x: Date.UTC(2020, 0, 2), y: 1997.501993 },
  { x: Date.UTC(2020, 1, 3), y: 2039.299008 },
  { x: Date.UTC(2020, 2, 2), y: 2053.02781 },
  { x: Date.UTC(2020, 3, 1), y: 1998.500903 },
  { x: Date.UTC(2020, 4, 1), y: 2009.292207 },
  { x: Date.UTC(2020, 5, 1), y: 2008.147043 },
  { x: Date.UTC(2020, 6, 1), y: 2023.733994 },
  { x: Date.UTC(2020, 7, 3), y: 2054.002589 },
  { x: Date.UTC(2020, 8, 1), y: 2041.681475 },
  { x: Date.UTC(2020, 9, 1), y: 2069.785519 },
  { x: Date.UTC(2020, 10, 2), y: 2088.184923 },
  { x: Date.UTC(2020, 11, 1), y: 2081.266408 },
  { x: Date.UTC(2021, 0, 4), y: 2095.433239 },
  { x: Date.UTC(2021, 1, 1), y: 2080.791816 },
  { x: Date.UTC(2021, 2, 1), y: 2053.30496 },
  { x: Date.UTC(2021, 3, 1), y: 2048.517357 },
  { x: Date.UTC(2021, 4, 3), y: 2024.901827 },
  { x: Date.UTC(2021, 5, 1), y: 2020.991744 },
  { x: Date.UTC(2021, 6, 1), y: 2031.187065 },
  { x: Date.UTC(2021, 7, 2), y: 2072.587734 },
  { x: Date.UTC(2021, 8, 1), y: 2054.396741 },
  { x: Date.UTC(2021, 9, 1), y: 2035.76772 },
  { x: Date.UTC(2021, 10, 1), y: 2016.490066 },
  { x: Date.UTC(2021, 11, 1), y: 2049.025587 },
  { x: Date.UTC(2022, 0, 3), y: 2015.738323 },
  { x: Date.UTC(2022, 1, 1), y: 1993.203607 },
  { x: Date.UTC(2022, 2, 1), y: 1996.540377 },
  { x: Date.UTC(2022, 3, 1), y: 1905.420149 },
  { x: Date.UTC(2022, 4, 2), y: 1837.109595 },
  { x: Date.UTC(2022, 5, 1), y: 1799.89616 },
  { x: Date.UTC(2022, 6, 1), y: 1794.859195 },
  { x: Date.UTC(2022, 7, 1), y: 1856.040629 },
  { x: Date.UTC(2022, 8, 1), y: 1742.744005 },
  { x: Date.UTC(2022, 9, 3), y: 1710.77741 },
  { x: Date.UTC(2022, 10, 1), y: 1689.744715 },
  { x: Date.UTC(2022, 11, 1), y: 1742.837608 },
  { x: Date.UTC(2023, 0, 3), y: 1668.178195 },
  { x: Date.UTC(2023, 1, 1), y: 1686.0935 },
  { x: Date.UTC(2023, 2, 1), y: 1639.669029 },
  { x: Date.UTC(2023, 3, 3), y: 1695.929038 },
  { x: Date.UTC(2023, 4, 1), y: 1686.661694 },
  { x: Date.UTC(2023, 5, 1), y: 1696.08041 },
  { x: Date.UTC(2023, 6, 3), y: 1685.45291 },
  { x: Date.UTC(2023, 7, 1), y: 1678.301121 },
  { x: Date.UTC(2023, 8, 1), y: 1683.229859 },
  { x: Date.UTC(2023, 9, 2), y: 1638.97725 },
  { x: Date.UTC(2023, 10, 1), y: 1657.971173 },
  { x: Date.UTC(2023, 11, 1), y: 1714.88786 },
  { x: Date.UTC(2024, 0, 1), y: 1845.251756, marker: { enabled: true } },
];
